<div class="row preferences client-todos strategy-list">
  <div class="column large-12 medium-12 small-12 foo-container icons-table">
    <div class="row add-share-buttons">
      <div class="column medium-9 small-11 text-right add-data">
        <input type="text" [(ngModel)]="searchKey" placeholder="Search firm" style="height: 30px; font-size: 18px;" (keyup)="filterData()"/>
      </div>
      <div class="column medium-3 small-1 add-data" *ngIf="org == 'test-taxplaniq' || org == 'trialtaxplaniq' || org == 'stag-taxplaniq'">
        <div class="compose-post float-right" style="margin-top: 5px;" (click)="addNewFirm()">
          <i class="material-icons">add</i><span class="compose-btn-text">NEW FIRM</span>
        </div>
      </div>
    </div>
    <div class="tab-container books-tab-container">
      <div class="row collapse tab-content clients-data">
        <div class="column medium-12 indy-tables client-todo-table badge-tables">
          <app-tracker-paginated-table [setObj]="taxStrategyTableData" *ngIf="hasTaxStrategyList" (onScroll)="handleScroll($event)" (onRowAction)="handleAction($event)"
                                   (onSort)="sortByColumn($event)"></app-tracker-paginated-table>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="reveal['editFirm']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['editFirm']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['editFirm']}">
    <div class="header" style="height: 50px; background-color: #16477a; padding: 15px; color: #fff;">
      <span class="float-left">Edit Firm</span>
      <span class="float-right pointer" (click)="hideReveal('editFirm')">X</span>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <div class="row">
            <div class="small-3 columns">
              <label>Name</label>
            </div>
            <div class="small-5 columns">
              <input type="text" placeholder="Name" [(ngModel)]="editStrategy.firmName">
            </div>
          </div>
        </div>
        <div class="small-12 medium-12">
          <div class="row">
            <div class="small-3 columns">
              <label>Trial Start</label>
            </div>
            <div class="small-5 columns">
              <input class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="editStrategy.trialStartDate"
                     placeholder="Trial Start Date" (valueChanged)="updateTrialDate($event,'trialStartDate')" [disabled]="true"/>
            </div>
          </div>
        </div>
        <div class="small-12 medium-12">
          <div class="row">
            <div class="small-3 columns">
              <label>Trial End</label>
            </div>
            <div class="small-5 columns">
              <input class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="editStrategy.trialEndDate"
                     placeholder="Trial End Date" (valueChanged)="updateTrialDate($event,'trialEndDate')" [disabled]="editStrategy.status === 'Paid'"/>
            </div>
          </div>
        </div>
        <div class="small-12 medium-12" style="margin-bottom: 15px;">
          <div class="row">
            <div class="small-3 columns">
              <label>Plan</label>
            </div>
            <div class="small-5 columns">
              <app-tpiq-select-dropdown [setData]="plansData" [includeNone]="false" (onValueSelect)="setPlan($event)"
                                     [setDefaultValue]="editStrategy.plan" [setSearchKey]="'plan'" [setPlaceHolder]="'Select Plan'" [setValueKey]="'plan'">
              </app-tpiq-select-dropdown>
            </div>
          </div>
        </div>
        <div class="small-12 medium-12">
          <div class="row">
            <div class="small-3 columns">
              <label>Status</label>
            </div>
            <div class="small-5 columns">
              <app-tpiq-select-dropdown [setData]="statusData" [includeNone]="false" (onValueSelect)="setStatus($event)"
                                     [setDefaultValue]="editStrategy.status" [setSearchKey]="'value'" [setPlaceHolder]="'Select Status'" [setValueKey]="'key'">
              </app-tpiq-select-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-padding-reveal">
          <button class="button small float-right" (click)="updateFirmData()">UPDATE</button>
        </div>
      </div>
    </div>
  </div>
</div>
